export enum PERIOD_TYPE {
    LAST_N_DAYS = 'LAST_N_DAYS',
    ANNUAL = 'ANNUAL',
    QUARTERLY = 'QUARTERLY',
    MONTHLY = 'MONTHLY',
    PREDEFINED = 'PREDEFINED',
    RANGE = 'RANGE' /* custom */,
}
